import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '../common';
import type { Reservation } from './types';

type Variables = {
  id: number;
};
export type ReservationAcceptCarAsIsResponse = {
  data: Reservation;
};

export const useReservationAcceptCarAsIs = createMutation<
  ReservationAcceptCarAsIsResponse,
  Variables,
  AxiosError
>({
  mutationFn: async (variables) =>
    client({
      url: `v2/reservations/${variables.id}/accept-car-as-is`,
      method: 'POST',
    })
      .then((response) => response.data)
      .catch((err: any) => {
        throw new Error(err.response.data.errors.join(', '));
      }),
});
